<template>
  <div>
    <el-autocomplete hide-loading v-model="selectValue" :fetch-suggestions="queryQwGroupNameSearch"
      placement="bottom" popper-class="my-autocomplete" :placeholder="placeholder" @select="editReceiveName"
      @blur='editReceiveName' :clearable="true">
      <!-- :clearable="true" -->
      <template #default="{ item }">
        <div class="warning" @click.stop v-if="item.type == 'warning'"><el-text class="mx-1" type="warning">{{ item.desc
            }}</el-text></div>
        <div v-else class="value">{{ item.value }}</div>
      </template>
    </el-autocomplete>
  </div>
</template>

<script setup>
import { getWxGroupListByName, editStudentReceiveWeChatInfo } from '@/api/common.js'
import { computed,reactive,ref } from 'vue';
import { ElNotification } from 'element-plus';

let selectList = [];
const emit = defineEmits(['update:modelValue','change','update:chatId'])
const props = defineProps({
  studentCode:{
    required:true
  },
  needSave:{
    type: Boolean,
    default: true
  },
  modelValue:{
    default:''
  },
  chatId:{
    default:''
  },
  placeholder:{
    default: '请选择'
  }
})
let defaultModelValue = props.modelValue;
const selectValue = computed({
  get: () => props.modelValue,
  set: (v) => {
    emit('update:modelValue',v || '')
  }
})


const queryQwGroupNameSearch = (queryString, cb) => {
  // if (!queryString) {
  //   cb([])
  //   return
  // };
  // console.log(queryString,selectValue.value)
  console.log('queryString',queryString)
  console.log('queryString.replace(/\n+|\t+| +/,"")',queryString.replace(/\n+|\t+| +/,''))
  getWxGroupListByName({
    keyword: queryString
  }).then(res => {
    let options = res.map(item=>({...item,value: item.groupName || item.chatGroupName}));
    if (options.length == 0) {
      cb([{ desc: '未查询到群名，请您自行键入群名称', type: 'warning' }])
      return;
    }
    if(options.length >= 10){
      options.push({ desc: '最多展示10个群组，更多请输入群名搜索', type: 'warning' })
    }
    cb(options)
    selectList = options;
  }).catch(err=>{

  })
}

const editReceiveName = () => {
  
  // console.log(selectValue.value)
  if(defaultModelValue == selectValue.value)return; // 若内容没有变化则不去请求
  setTimeout(()=>{
    let chatId = '';
    selectList.some(item=>{
      if(item.groupName == selectValue.value){
        chatId = item.chatId
        return true;
      }
    })
    
    editStudentReceiveWeChatInfo({
      receiveWeChatGroupName: selectValue.value || '',
      studentCode: props.studentCode,
      chatId:selectValue.value ? chatId : ''
    }).catch(err=>{
      if(!props.needSave)return;
      ElNotification({
        title: '提示',
        message: `群聊信息更新失败（${err}）`,
        type: 'error',
      })
    })
    defaultModelValue = selectValue.value
    
    emit('update:chatId',chatId)
    emit('change',selectValue.value || '')
  },20)
}

</script>

<style lang="scss" scoped></style>